import API from '../../sunwiseAPI';
const ENTITY = 'aftersales-end';

export const setReportEnd = (uuid) =>
    API.post(`/api/v1/${ENTITY}/${uuid}/sunpay`);
